"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _ = require("../..");
var _GroupSessionRow = _interopRequireDefault(require("./GroupSessionRow"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var GroupSessionsList = function GroupSessionsList(_ref) {
  var upcomingSessions = _ref.upcomingSessions,
    setSessionsModal = _ref.setSessionsModal,
    rsvpProcessing = _ref.rsvpProcessing,
    rsvpsBySessionId = _ref.rsvpsBySessionId,
    comingSoon = _ref.comingSoon,
    handleCheckedSessions = _ref.handleCheckedSessions,
    selectedSessionIds = _ref.selectedSessionIds,
    group = _ref.group,
    handlePromptCancel = _ref.handlePromptCancel,
    setShowCancelModal = _ref.setShowCancelModal,
    setCancelSession = _ref.setCancelSession,
    registerDisabled = _ref.registerDisabled,
    onClickSignUp = _ref.onClickSignUp,
    handleClickRegister = _ref.handleClickRegister,
    md = _ref.md;
  var _useAuth = (0, _.useAuth)(),
    isAuthenticated = _useAuth.isAuthenticated;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, md && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "close-24",
    size: 24,
    className: "float-right cursor-pointer mt-[24px] mr-[24px]",
    onClick: function onClick() {
      return setSessionsModal(false);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium text-black mr-[24px] pl-[24px] pt-[24px]"
  }, "Registration")), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-label-light mt-[4px] text-black mb-[25px] pl-[24px] md:mt-[24px] md:tw-subtitle-sm-light"
  }, "Select up to ", upcomingSessions.length, " session(s) to register"), upcomingSessions.length > 0 && /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: rsvpProcessing,
    wrapperClassName: "group-sessions"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "px-[24px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "border-0 border-t border-solid border-grey-20 mb-[16px]"
  }, upcomingSessions.map(function (session, index) {
    return /*#__PURE__*/_react.default.createElement(_GroupSessionRow.default, {
      key: session.id,
      session: session,
      rsvp: rsvpsBySessionId[session.id],
      comingSoon: comingSoon,
      handleCheckedSessions: handleCheckedSessions,
      isChecked: selectedSessionIds.includes(session.id),
      group: group,
      handlePromptCancel: handlePromptCancel,
      setShowCancelModal: setShowCancelModal,
      setCancelSession: setCancelSession,
      setSessionsModal: setSessionsModal,
      isLastRow: index === upcomingSessions.length - 1
    });
  })))), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "grey-20 mt-[12px]"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'py-[32px] px-[72px]': md,
      'flex flex-col items-center bg-white w-full py-[24px] px-[28px] shadow-10': !md
    })
  }, isAuthenticated ? /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    className: "w-full",
    onClick: function onClick() {
      return handleClickRegister();
    },
    disabled: registerDisabled
  }, "Register") : /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    className: "w-full",
    onClick: onClickSignUp
  }, "Sign up to register")));
};
GroupSessionsList.propTypes = {
  upcomingSessions: _propTypes.default.array,
  setSessionsModal: _propTypes.default.func,
  rsvpProcessing: _propTypes.default.bool,
  rsvpsBySessionId: _propTypes.default.array,
  comingSoon: _propTypes.default.bool,
  handleCheckedSessions: _propTypes.default.func,
  selectedSessionIds: _propTypes.default.array,
  group: _propTypes.default.object,
  handlePromptCancel: _propTypes.default.func,
  setShowCancelModal: _propTypes.default.func,
  setCancelSession: _propTypes.default.func,
  registerDisabled: _propTypes.default.bool,
  onClickSignUp: _propTypes.default.func,
  handleClickRegister: _propTypes.default.func
};
var _default = GroupSessionsList;
exports.default = _default;